'use strict';

angular.module('theme').directive('orderSimpleButton', function ($window, CartService, ArticleService, TrackerService) {
	return {
		restrict: 'E',
		templateUrl: 'component/order-simple-button.html',
		scope: {
			productId: '@',
			outline: '@'
		},
		controller: function ($scope) {
			ArticleService.getProduct($scope.productId).then(function (product) {
				$scope.product = product;
			});

			$scope.add = function () {
				CartService.add($scope.product, 4).then(function () {
					TrackerService.addToCart($scope.product);

					// redirect to cart
					$window.location.href = '/order/';
				});
			};
		}
	};
});
